import { getAmplitudeInstance } from '../amplitudeHelpers';

type logThreeDSecureChallengeFailedParams = {
  checkout_session_id: string;
  error_code?: string;
  failure_reason?: string;
  payment_method?: string;
  product_id?: string;
  purchase_screen_type_plan?: string;
  purchase_type?: string;
  upsell_trigger?: string;
};

/**
 * The 3DS challenge did not produce a result token because Recurly.js emitted an error. This covers user cancellation (captured via failure_reason) as well as authentication failures, since the Recurly.js wrapper surfaces both through a single error callback. Distinct from 'purchase failed', which covers a decline on the purchase request itself.
 * @param params - Attributes to log with the amplitude event
 * @param params.checkout_session_id - The client-generated checkout session id used to correlate the 3DS retry through to the final purchase outcome.
 * @param params.error_code - The Recurly.js error code returned by the failed challenge.
 * @param params.failure_reason - A human-readable reason for the failure. Set to 'canceled' when the Recurly error code can be confidently identified as a user cancellation; otherwise the underlying error description.
 * @param params.payment_method - The method of payment used for the purchase (e.g. credit_card, apple_pay, paypal).
 * @param params.product_id - The Recurly plan code / product id being purchased.
 * @param params.purchase_screen_type_plan - The plan shown on the purchasing screen (e.g. trial, non-trial, promo).
 * @param params.purchase_type - The purchase flow that triggered 3DS (e.g. initial_subscription, upgrade, gift).
 * @param params.upsell_trigger - The action that triggered the upsell to display.
 */
const logThreeDSecureChallengeFailed = (
  {
    checkout_session_id,
    error_code,
    failure_reason,
    payment_method,
    product_id,
    purchase_screen_type_plan,
    purchase_type,
    upsell_trigger
  }: logThreeDSecureChallengeFailedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    '3ds challenge failed',
    {
      'checkout session id': checkout_session_id,
      'error code': error_code,
      'failure reason': failure_reason,
      'payment method': payment_method,
      'product id': product_id,
      'purchase screen type plan': purchase_screen_type_plan,
      'purchase type': purchase_type,
      'upsell trigger': upsell_trigger
    },
    callback
  );
};

export default logThreeDSecureChallengeFailed;
